import { useState } from "react";
import BaseAppContainer from "../base--app-container/BaseAppContainer";
import Styles from "./DevSkills.module.scss";
import LeftPanelMenu from "../left-panel-menu/LeftPanelMenu";
import { APP_KEY_IDS } from "../../constants/constants";
import { getCurrentOption } from "../../global/functions/functrions";

interface SkillsProps {
  skillsData: any
  proficiency: any;
}

const DevSkills = ({ skillsData, proficiency }: SkillsProps) => {

  const leftMenu = [
    {
      id: "AIML",
      label: "AIML"
    },
    {
      id: "Android",
      label: "Android"
    },
    {
      id: "ChromeExtension",
      label: "Chrome Extension"
    },
    {
      id: "Databse",
      label: "Databse"
    },
    {
      id: "Desktop",
      label: "Desktop"
    },
    {
      id: "OS&Other",
      label: "OS & Other"
    },
    {
      id: "Tools&Technologies",
      label: "Tools & Technologies"
    },
    {
      id: "UI Designing",
      label: "UI Designing"
    },
    {
      id: "WebApp",
      label: "Web App"
    },
    {
      id: "WebSites",
      label: "Website"
    }
  ]


  const [activeOption, setActiveOption] = useState<any>("aiml");


  return (
    <BaseAppContainer
      appId={APP_KEY_IDS.DEV_SKILLS}
      loadFromX={30}
      width={1000}
      height={600}
      title={skillsData[getCurrentOption(activeOption)]?.label || "Development Skills"}
      SideBar={
        <>
          {skillsData && <LeftPanelMenu menuContent={Object.values(skillsData)} activeValue={activeOption} handleOptionClick={setActiveOption} />}
        </>
      }
      MainScreen={
        <div className={Styles.container}>
          <div className={Styles.skills}>
            {activeOption && Object.keys(skillsData).length ? 
              Object.keys(skillsData[getCurrentOption(activeOption)]?.skills).map((key) => {
                return (
                  <a className={Styles.skill_card} href={skillsData[getCurrentOption(activeOption)].skills[key].skillLink} key={key} target="_blank">
                    <div className={Styles.skill_icon}>
                      <img src={skillsData[getCurrentOption(activeOption)].skills[key].skillIcon} />
                    </div>
                    <div className={Styles.skill_name}>
                      {skillsData[getCurrentOption(activeOption)].skills[key].skillName}
                    </div>
                  </a>

                )
              })
            :null}
          </div>
          <div className={Styles.proficiency_container}>
            <div className={Styles.title}>
              Proficiency
            </div>
            <div className={Styles.proficiencies}>
              
            {
              proficiency && Object.keys(proficiency).map((key: string) => {
                return (
                  <div className={Styles.proficiency_card} key={proficiency[key].pname}>
                    <div className={Styles.card}>
                      <div className={Styles.label}>
                        {proficiency[key].pname}
                      </div>
                      <div className={Styles.experience}>
                        {proficiency[key].pyrs}
                      </div>
                      <div className={Styles.prcnt}>
                        {proficiency[key].pprcnt}
                      </div>
                    </div>
                  </div>
                )
              })
            }
            </div>
          </div>
        </div>
      }
    />
  )
}

export default DevSkills
